import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from "class-validator";
import { CustomCommonValidator } from './customCommonValidator'
@ValidatorConstraint()
export class ContractStructureValidation extends CustomCommonValidator implements ValidatorConstraintInterface {


    validate(dynamicProperties: any, validationArguments: ValidationArguments) {
        let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
        let result: boolean = true;
        const validator = this.getValidator();
        this.message = "";
        if (properties.find(p => p == "cost") != null) {
            let costItem: CostItem = dynamicProperties['cost'] as CostItem;
            if (!validator.isNotEmpty(costItem.structure.type)) {
                this.message = this.message.concat("contract cost structure type is required <br />");
                result = false;
            }
            if (!validator.isNotEmpty(costItem.structure.mode)) {
                this.message = this.message.concat("contract cost structure mode is required <br />");
                result = false;
            }
            if (!validator.isNotEmpty(costItem.structure.crossingDateBandBehaviour)) {
                this.message = this.message.concat("contract cost structure crossingDateBandBehaviour is required <br />");
                result = false;
            }
            if (costItem.structure.isCustomOccupancyConfig && !validator.arrayMinSize(costItem.structure.customOccupancyConfigs, 1)) {
                this.message = this.message.concat("contract cost structure 'custom occupancy configuration' is required <br />");
                result = false;
            }
            if (!costItem.structure.isCustomOccupancyConfig && !validator.isNotEmpty(costItem.structure.maxPax)) {
                this.message = this.message.concat("contract cost structure 'max pax' is required <br />");
                result = false;
            }
        }
        if (properties.find(p => p == "price") != null) {
            let priceItem: PriceItem = dynamicProperties['price'] as PriceItem;
            if (!validator.isNotEmpty(priceItem.structure.type)) {
                this.message = this.message.concat("contract price structure type is required <br />");
                result = false;
            }
            if (!validator.isNotEmpty(priceItem.structure.mode)) {
                this.message = this.message.concat("contract price structure mode is required <br />");
                result = false;
            }
            if (!validator.isNotEmpty(priceItem.structure.crossingDateBandBehaviour)) {
                this.message = this.message.concat("contract price structure crossingDateBandBehaviour is required <br />");
                result = false;
            }
            if (priceItem.structure.isCustomOccupancyConfig && !validator.arrayMinSize(priceItem.structure.customOccupancyConfigs, 1)) {
                this.message = this.message.concat("contract price structure 'custom occupancy configuration' is required <br />");
                result = false;
            }
            if (!priceItem.structure.isCustomOccupancyConfig && !validator.isNotEmpty(priceItem.structure.maxPax)) {
                this.message = this.message.concat("contract price structure 'max pax' is required <br />");
                result = false;
            }
        }
        return result;
    }
    defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
        return this.message;
    }
}



// WEBPACK FOOTER //
// ./src/core/customValidator/contractStructureValidator.ts